import { PureComponent, PropsWithChildren } from "react";

export default class InventoryFilterAdvancedFilter extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-inventory-filter__adv-filter">
        {this.props.children}
      </div>
    );
  }
}
